module.exports = __webpack_public_path__ + "static/media/skills_swift.7582e6ba.png";